import React from 'react';
import { useLocation } from './LocationContext';

export function withLocation<Props>(Component: any) {
  return (props: Props) => {
    const location = useLocation();
    return <Component {...(props as Props)} {...location} />;
  };
}
